import * as React from 'react';
import { NavLink } from '../../model';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Divider, IconButton, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@mui/material';

export interface NavItemList {
  menuItems: NavLink[];
  parentItems?: NavItemList;
  backLabel?: string;
}

export interface NavMenuItemProps {
  item: NavLink;
  previous?: NavItemList;
  onClick?: (item: NavLink, previous?: NavItemList) => void;
}

export const NavMenuItem = (props: NavMenuItemProps) => {
  return props.item.separator ? <Divider /> : <NavItemWithText {...props} />;
};

export const NavMenuBack = (props: NavMenuItemProps) => {
  const onNavMenuBackClick = () => {
    if (props.onClick) {
      props.onClick(props.item, props.previous);
    }
  };
  return (
    <ListItem button onClick={onNavMenuBackClick}>
      <>
        <ListItemIcon>
          <IconButton edge="start" aria-label="back" onClick={onNavMenuBackClick}>
            <ChevronLeftIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemText primary={props.item.text} />
      </>
    </ListItem>
  );
};

const NavItemWithText = (props: NavMenuItemProps) => {
  const { item, onClick } = props;

  const onNavClick = () => {
    if (onClick) {
      onClick(props.item, props.previous);
    }
  };

  return item.path || item.children ? (
    <ListItem button onClick={onNavClick}>
      <ListItemText primary={props.item.text} />
      {item.children && item.children.length > 0 && <ChevronRightIcon />}
    </ListItem>
  ) : (
    // sx={{ fontWeight: 'bold', fontSize: 'inherit' }}
    <ListSubheader>{item.text}</ListSubheader>
  );
};
